import React, { useEffect, useState } from 'react';

export default function Error() {
   
    const [errorState, setErrorState] = useState({
        loginMsg:"",
        failureMsg:""
    });
    
    useEffect(() => {
        setComment();
    },[]);

    const setComment = () => {
        var lang = localStorage.getItem("language");
    
        if (lang === 'en') {
            setErrorState({
                loginMsg:"Failed Login",
                failureMsg:"Please Check your ID and Password..."
            });
        } else {
            setErrorState({
                loginMsg:"Login 을 할 수 없습니다.",
                failureMsg:"사용자 로그인 정보를 확인해 주세요.!"
            });
        }
    }

    return(
        <div className="container-fluid">
            <div className="row justify-content-center">
                <div className="col-xl-10 col-lg-12 col-md-9">
                    <div className="card o-hidden border-0 shadow-lg my-5">
                        <div className="card-body p-0">
                            <div className="row">
                                <div className="col-lg-7">
                                    <div className="p-5">
                                        <h1 id="loginMsg" name="loginMsg" className="h1 text-gray-900 mb-4">{errorState.loginMsg}</h1>
                                        <div className="lead text-gray-800 mb-5">
                                            <h1 id="failureMsg" name="failureMsg" className="h5 text-gray-900 mb-4">{errorState.failureMsg}</h1>
                                        </div>
                                        <h1 className="h5 text-gray-900 mb-4"><a href="/">&larr; Back to Login Page</a></h1>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
    
}
